module.exports = __webpack_public_path__ + "static/media/checkout-success.6dddc93c.png";